import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { LocalBusinessSchema } from "./components/SEO";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import BambooPage from "./pages/BambooPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import DevisPage from "./pages/DevisPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";
import CGVPage from "./pages/CGVPage";
import CalculateurPage from "./pages/CalculateurPage";
import FormulairePartenairePage from "./pages/FormulairePartenairePage";
import { WhatsAppButton } from "./components/WhatsAppButton";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const hide = () => {
      const b = document.getElementById("emergent-badge");
      if (b) b.style.setProperty("display", "none", "important");
    };
    hide();
    const t = setInterval(hide, 1000);
    return () => clearInterval(t);
  }, []);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <LocalBusinessSchema />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/le-bambou" element={<BambooPage />} />
          <Route path="/nos-produits" element={<ProductsPage />} />
          <Route path="/produit/:slug" element={<ProductDetailPage />} />
          <Route path="/demande-de-devis" element={<DevisPage />} />
          <Route path="/demande-de-devis/" element={<DevisPage />} />
          <Route path="/formulaire_partenaire" element={<FormulairePartenairePage />} />
          <Route path="/formulaire_partenaire/" element={<FormulairePartenairePage />} />
          <Route path="/calculateur" element={<CalculateurPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
          <Route path="/cgv" element={<CGVPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
    </HelmetProvider>
  );
}

export default App;
